import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class ProgramTypesDisplayListComponent implements IController {

  programIds: any;
  isRow: any;
  rowLimit: any;
  disabledIds: any;

  onChange: Function;

  private readonly siteProgramTypes: any[];
  private displayItems: any;

  constructor(private splitService) {
    this.siteProgramTypes = this.splitService.getSiteProgramTypes();
  }

  $onInit() {

    if (!this.rowLimit) {
      this.rowLimit = 10;
    }

    this.setItems(this.programIds);
  }

  $onChanges(changes) {
    if (changes.programIds && !changes.programIds.isFirstChange()) {
      this.setItems(this.programIds);
    }
  }

  onRemoveItem(id) {
    this.onChange({
      programIds: _.filter(this.programIds, (i) => {
        return i !== id
      })
    });
  }

  onReset() {
    this.onChange({programIds: []});
  }

  private setItems(programIds) {
    if (programIds && programIds.length) {
      const displayItems = [];
      _.forEach(this.siteProgramTypes, (p) => {
        if (_.includes(programIds, p.id)) {
          displayItems.push({id: p.id, value: p.type})
        }
      })
      this.displayItems = displayItems;
    } else {
      this.displayItems = [];
    }
  }


}

angular
  .module('bringoz.admin.commons')
  .component('programTypesDisplayList', {
    bindings: {
      programIds: '<',
      isRow: '<?',
      rowLimit: '<?',
      disabledIds: '<?',
      onChange: '&'
    },
    template: require('./program-types-display-list.html').default,
    controller: ProgramTypesDisplayListComponent
  });
